import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { UserModel } from "@/modules/users/models/userModel"

@Serializable
export class SupplierLocationListView {
  uid: string = ""
  name: string = ""
  vatNumber: string = ""
  country: string = ""
  url: string = ""
  isSelected: boolean = false
  isWaitingApproval: boolean = false
  contacts: UserModel[] = []

  constructor(data: Partial<SupplierLocationListView> | null = null) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
